/**
 * Global interaction settings for 2-6-year-old hands:
 * - optional wake lock while inside a module (the screen
 *   does not turn off halfway through a song).
 */

interface WakeLockSentinelLike {
  release: () => Promise<void>;
}

/**
 * Requests the screen wake lock if the platform supports it (Chrome/Android
 * WebView, modern browsers). Returns a release function; failures are
 * ignored (the API requires visibility and may be denied).
 */
export function acquireWakeLock(): () => void {
  let sentinel: WakeLockSentinelLike | null = null;
  const nav = navigator as Navigator & {
    wakeLock?: { request: (type: "screen") => Promise<WakeLockSentinelLike> };
  };
  void (async () => {
    try {
      sentinel = (await nav.wakeLock?.request("screen")) ?? null;
    } catch {
      // denied or unsupported: the screen will turn off normally
    }
  })();
  return () => {
    void sentinel?.release().catch(() => undefined);
    sentinel = null;
  };
}
